import {AfterViewInit, Component, OnInit, ViewChild} from '@angular/core';
import {ITableHeader, TableComponent} from '../../../shared/table/TableComponent';
import {
    CompanyAddressChangeRequestViewModel,
    PagedListOfCompanyAddressChangeRequestViewModel
} from '../../../../services/api.client';
import {CompanyAddressChangeRequestService} from '../../../../services/companyAddressChangeRequest.service';
import {tap} from 'rxjs/operators';

@Component({
    selector: 'app-address-change-requests',
    templateUrl: './address-change-requests.component.html',
    styleUrls: ['./address-change-requests.component.scss'],
    standalone: false
})
export class AddressChangeRequestsComponent implements OnInit, AfterViewInit {
    @ViewChild(TableComponent)
    table: TableComponent;

    requestsList: PagedListOfCompanyAddressChangeRequestViewModel;

    currentSortName = 'EnteredDate';
    currentSorting = true;

    tableHeaders: ITableHeader[] = [
        {text: 'Company', sortKey: 'CompanyName'},
        {text: 'Old Address', sortKey: 'OldAddress1'},
        {text: 'New Address', sortKey: 'Address1'},
        {text: 'Requested By', sortKey: 'RequestedByName'},
        {text: 'Date', sortKey: 'EnteredDate', ascending: false},
        {text: 'Actions', sortKey: null}
    ];

    limit = 10;
    currentPage = 1;
    totalCount = 0;

    constructor(
        private _service: CompanyAddressChangeRequestService
    ) {
    }

    ngOnInit(): void {
    }

    ngAfterViewInit(): void {
        this.loadRequests();
    }

    sortRequests(options: ITableHeader): void {
        if (!options.sortKey) return;
        this.currentSortName = options.sortKey;
        this.currentSorting = !options.ascending;
        this.loadRequests();
    }

    setLimit(limit: number): void {
        this.limit = limit;
        this.loadRequests();
    }

    setPage(page: number): void {
        setTimeout(() => {
            this.currentPage = page;
            this.loadRequests();
        });
    }

    loadRequests(): void {
        const request$ = this._service.getPendingRequests(
            this.limit,
            (this.currentPage - 1) * this.limit,
            this.currentSortName,
            this.currentSorting
        ).pipe(
            tap((result) => {
                this.requestsList = result;
                this.totalCount = result.totalCount;
            })
        );
        this.table.request = request$;
    }

    approveRequest(request: CompanyAddressChangeRequestViewModel): void {
        this._service.approveRequest(request.id).subscribe(() => {
            this.loadRequests();
        });
    }

    denyRequest(request: CompanyAddressChangeRequestViewModel): void {
        this._service.denyRequest(request.id).subscribe(() => {
            this.loadRequests();
        });
    }

    formatAddress(address1: string, address2: string, city: string, state: string, zipCode: string): string {
        const parts = [address1, address2, city, state, zipCode].filter(p => p);
        return parts.join(', ') || 'N/A';
    }
}
